import SSOPayment from './SSOPayment';

export default SSOPayment;
